import script from "./PandoraTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraTabs.vue?vue&type=script&setup=true&lang=js"

import "./PandoraTabs.vue?vue&type=style&index=0&id=7289c4f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7289c4f6"]])

export default __exports__